export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/d70de408f224-tooliconticketnumber.jpg',
  },
  title: 'What is the notice number on the parking ticket?',
}
